import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardHolderComponent } from '../../../components/cards/card-holder/card-holder.component';
import { GameViewModel } from '../../models/game-view.model';

@Component({
    selector: 'app-game-table',
    imports: [CommonModule, CardHolderComponent],
    templateUrl: './game-table-template.html'
})
export abstract class GameTableBaseComponent {
    @Input()
    data!: GameViewModel;
    @Input() isVoid = false;
}
